import { useSyncExternalStore } from "react";

const MOBILE_CLINIC_UNSUPPORTED_MAX_WIDTH = 767;

export function isMobileClinicUnsupportedViewport() {
  if (typeof window === "undefined") {
    return false;
  }

  if (typeof window.matchMedia === "function") {
    return window.matchMedia(
      `(max-width: ${MOBILE_CLINIC_UNSUPPORTED_MAX_WIDTH}px)`,
    ).matches;
  }

  return (window.innerWidth || 0) <= MOBILE_CLINIC_UNSUPPORTED_MAX_WIDTH;
}

function subscribeToViewportChange(callback) {
  if (typeof window === "undefined") {
    return () => {};
  }

  window.addEventListener("resize", callback);
  window.addEventListener("orientationchange", callback);

  return () => {
    window.removeEventListener("resize", callback);
    window.removeEventListener("orientationchange", callback);
  };
}

export function useIsMobileClinicUnsupportedViewport() {
  return useSyncExternalStore(
    subscribeToViewportChange,
    isMobileClinicUnsupportedViewport,
    () => false,
  );
}
